import { api } from './api-client'
import type { IntegrationSyncStats } from './integrations'
import { DEFAULT_LOCALE, LOCALE_META, type Locale } from './i18n/config'

export type NotificationSeverity = 'ok' | 'partial_error' | 'error'
export type NotificationTrigger = 'cron' | 'manual' | 'webhook'

export interface NotificationOrg {
  _id: string
  name: string
  slug: string
}

export interface IntegrationRunNotification {
  _id: string
  organizationId: NotificationOrg
  kind: 'integration_run'
  severity: NotificationSeverity
  runLogId: string
  integrationId: string
  integrationName: string
  trigger: NotificationTrigger
  statsSummary: IntegrationSyncStats
  errorMessage?: string
  finishedAt: string
  read: boolean
}

// Invitado con cuenta a un panorama (ver ciudad-server PanoramasService.addInvitee).
export interface PanoramaInviteNotification {
  _id: string
  kind: 'panorama_invite'
  panoramaId: string
  panoramaTitle: string
  creatorName: string
  createdAt: string
  read: boolean
}

export type Notification = IntegrationRunNotification | PanoramaInviteNotification

export interface NotificationSuccess {
  eventId: string
  slug: string
  title: string
  action: 'created' | 'updated'
}

export interface NotificationFailure {
  externalId: string
  message: string
}

// failures/succeeded/stats solo tienen datos reales para 'integration_run'
// (el backend los devuelve vacíos/omitidos para 'panorama_invite').
export type NotificationDetail = Notification & {
  failures: NotificationFailure[]
  succeeded: NotificationSuccess[]
  stats?: IntegrationSyncStats
}

export interface NotificationsPage {
  data: Notification[]
  meta: { total: number; page: number; limit: number; totalPages: number }
}

export function formatNotificationDate(iso: string, lang: Locale = DEFAULT_LOCALE) {
  return new Date(iso).toLocaleDateString(LOCALE_META[lang].intl, {
    day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit',
  })
}

export const notificationsApi = {
  unreadCount: () => api.get<{ count: number; latestAt: string | null }>('/notifications/unread-count'),
  list: (page = 1, limit = 20) =>
    api.get<NotificationsPage>(`/notifications?page=${page}&limit=${limit}`),
  get: (id: string) => api.get<NotificationDetail>(`/notifications/${id}`),
  markAllRead: () => api.post<{ updated: number }>('/notifications/read-all', {}),
}
